
import React from 'react';
import MediaCentreComponent from '../components/Common/MediaCentre';

function MediaCentre() {
    return (
        <div className='totalPage' id='mediaCentrePage'>
            <section className="wrapper">
                <div className="container mt-6 pb-6">
                    <MediaCentreComponent />
                </div>
            </section>
        </div>
    );
}

export default MediaCentre;